import Vue from "vue";

/**
 * @deprecated  
 */
export const action = {
  // 病院側のお知らせプレビュー
  SHOW_POST_PREVIEW: "showPostPreview",
  // 病院側の事前問診返信用メッセージテンプレート
  MESSAGE_QUOTE: "messageQuote",
  DECIDE_QUOTE: "desideQuote",
  // 病院側のお知らせテンプレート
  TEMPLATE_NEWS_QUOTE: "templateNewsQuote",
  DECIDE_TEMPLATE_NEWS_QUOTE: "decideTemplateNewsQuote",
  // 病院側の個別メッセージテンプレート
  TEMPLATE_MESSAGE_QUOTE: "templateMessageQuote",
  DECIDE_TEMPLATE_MESSAGE_QUOTE: "decideTemplateMessageQuote",
  // 病院側サイドバー
  TOGGLE_COLLAPSED: 'toggleCollapsed'
};

/**
 * @deprecated
 */
export const eventBus = new Vue({
  methods: {
    // 病院側のお知らせプレビュー
    showPostPreview() {
      this.$emit(action.SHOW_POST_PREVIEW);
    },
    // 病院側の事前問診返信用メッセージテンプレート
    quoteMessage(message) {
      this.$emit(action.MESSAGE_QUOTE, message);
    },
    decideQuote() {
      this.$emit(action.DECIDE_QUOTE);
    },
    // 病院側のお知らせテンプレート
    bodyNews(title, body) {
      this.$emit(action.TEMPLATE_NEWS_QUOTE, { title: title, body: body});
    },
    decideTemplateNewsQuote() {
      this.$emit(action.DECIDE_TEMPLATE_NEWS_QUOTE);
    },
    // 病院側の個別メッセージテンプレート
    setMessageTemplate(body) {
      this.$emit(action.TEMPLATE_MESSAGE_QUOTE, { body: body });
    },
    decideTemplateMessageQuote() {
      this.$emit(action.DECIDE_TEMPLATE_MESSAGE_QUOTE);
    },
    // 病院側サイドバー
    toggleCollapsed() {
      this.$emit(action.TOGGLE_COLLAPSED);
    },
  }
});
